import styled from 'styled-components';
import { Breakpoints, FontWeight } from '../../../styled/constants';
import { globalSystemColors } from '../../../styled/theme/constants';

export const Section = styled.section`
  position: relative;
  margin-bottom: 50px;
  padding: 50px 15px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  border-radius: 32px;
  background: url('/static/images/pasha/request-bg.jpg') center/cover no-repeat;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0 0 0 / 0.32);
  }
`;

export const Title = styled.h2`
  margin: 0 0 15px;
  text-align: left;
  font-size: 24px;
  font-weight: 700;
  color: ${globalSystemColors.cocoaBrown};

  @media (max-width: ${Breakpoints.tablet}px) {
    font-size: 20px;
  }
`;

export const Subtitle = styled.p`
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 1.5;
  color: ${globalSystemColors.cocoaBrown};
  opacity: 0.85;

  @media (max-width: ${Breakpoints.tablet}px) {
    font-size: 14px;
  }
`;

export const Card = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 940px;
  border-radius: 24px;
  padding: 20px 15px;
  background: ${globalSystemColors.white};
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);

  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 25px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 40px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;

  .hs-form fieldset {
    margin: 0;
    padding: 0;
    border: 0;
    display: contents;
  }

  .hs-form {
    display: grid;
    grid-template-columns: 1fr;
    align-items: start;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    .hs-form {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      column-gap: 20px;
      grid-template-areas:
        'fn    interests'
        'ln    interests'
        'em    interests'
        'ph    interests'
        'msg   interests'
        'cons  submit';
    }
    .hs_firstname {
      grid-area: fn !important;
    }
    .hs_lastname {
      grid-area: ln !important;
    }
    .hs_email {
      grid-area: em !important;
    }
    .hs_phone {
      grid-area: ph !important;
    }
    .hs_message {
      grid-area: msg !important;
    }

    .hs-interest_new {
      grid-area: interests !important;
      align-self: start;
    }

    .legal-consent-container {
      grid-area: cons !important;
      align-self: end;
      margin-bottom: 5px;
      font-size: 15px;
      font-weight: 400;
      color: ${globalSystemColors.cocoaBrown};

      a {
        text-decoration: none;
      }

      label {
        display: flex;
        align-items: center;

        span {
          margin-left: 8px;
        }
      }
    }
    .hs_submit,
    .actions {
      grid-area: submit !important;
      justify-self: end;
      align-self: center;
      margin: 0 !important;
      width: 100%;
    }

    .actions .hs-button {
      width: 100%;
      min-width: 200px;
    }
  }

  .hs-form-field {
    position: relative;
    width: 100% !important;
  }

  .hs-form-field > .input {
    position: relative;
    z-index: 2;
    margin-right: 0 !important;
  }

  .hs-form-field:not(.hs-message) > label {
    position: absolute;
    left: 30px;
    top: 14px;
    margin: 0;
    z-index: 3;
    pointer-events: none;
    color: ${globalSystemColors.heatheredGrey};
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
    transform-origin: left top;
    transition:
      top 0.15s,
      transform 0.15s,
      opacity 0.15s;
  }

  .hs-input,
  select.hs-input,
  textarea.hs-input {
    width: 100%;
    position: static;
    box-sizing: border-box;
    padding: 25px 15px 9px;
    border: 1px solid ${({ theme }) => theme.colors.border.secondaryReverse};
    background: ${({ theme }) => theme.colors.background.tertiaryReverse};
    border-radius: 14px;
    font-size: 16px;
    color: ${globalSystemColors.cocoaBrown};
    outline: none;
  }

  .hs-input::placeholder {
    color: ${globalSystemColors.heatheredGrey};
    opacity: 1;
  }

  .hs-input:focus {
    border-color: ${globalSystemColors.blue};
    background: ${globalSystemColors.white};
  }

  .hs-form-field:not(.hs-message):focus-within > label,
  .hs-form-field:not(.hs-message):has(input.hs-input:not(:placeholder-shown))
    > label,
  .hs-form-field:not(.hs-message):has(select.hs-input:valid) > label,
  .hs-form-field.has-value > label {
    transform: translateY(-12px) scale(0.86);
    opacity: 0.95;
    font-size: 14px;
  }

  .hs_message > label {
    position: static !important;
    margin: 0 0 15px;
    color: ${globalSystemColors.cocoaBrown};
    font-size: 16px;
    font-weight: 500;
  }

  textarea.hs-input {
    margin-top: 15px;
    min-height: 90px;
    height: auto;
    resize: vertical;
    padding: 12px 15px;
  }

  .hs_phone .input .hs-fieldtype-intl-phone {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid ${({ theme }) => theme.colors.border.secondaryReverse};
    background: ${({ theme }) => theme.colors.background.tertiaryReverse};
    border-radius: 14px;
    padding: 18px 0 0 15px;
    height: 54px;
    width: 100%;
  }

  .hs_phone .input select.hs-input {
    flex: 0 0 70px;
    max-width: 70px;
    border: 0;
    background: transparent;
    padding: 0;
    height: 100%;
  }

  .hs_phone .input input.hs-input[type='tel'] {
    flex: 1 1 auto;
    min-width: 0;
    border: 0;
    background: transparent;
    padding: 0 10px;
    height: 100%;
    width: auto !important;
    padding-left: 14px !important;
    border-radius: 0;
    position: relative;
  }

  .hs_phone .input .hs-fieldtype-intl-phone::after {
    content: '';
    position: absolute;
    top: 68%;
    transform: translateY(-50%);
    left: 92px;
    width: 1px;
    height: 20px;
    background: ${({ theme }) => theme.colors.border.secondaryReverse};
    pointer-events: none;
  }

  .hs_phone.has-value > label {
    transform: translateY(-12px) scale(0.86);
    opacity: 0.95;
  }

  .hs-form-field {
    &.hs-interest_new .inputs-list {
      margin: 0;
      padding: 0;
      list-style: none;
      display: grid;
      grid-template-columns: 1fr;
      row-gap: 20px;
    }

    &.hs-interest_new > label {
      position: static;
      font-size: 16px !important;
      font-weight: 500;
      color: ${globalSystemColors.cocoaBrown};
      opacity: 1 !important;
    }

    &.hs-interest_new > .input {
      margin-top: 15px;
    }

    .hs-form-checkbox label {
      display: flex;
      gap: 10px;
      align-items: flex-start;
    }

    .hs-form-checkbox input[type='checkbox'] {
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      margin: 0;
      padding: 0;
    }

    .hs-form-checkbox .hs-form-checkbox-display {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      padding-left: 26px;
    }

    .hs-form-checkbox .hs-form-checkbox-display::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border: 1px solid #eaebf2;
      border-radius: 5px;
      background: ${globalSystemColors.white};
      box-sizing: border-box;
      transition:
        border-color 0.15s,
        box-shadow 0.15s,
        background-color 0.15s;
    }

    .hs-form-checkbox input[type='checkbox']:checked + span::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 45%;
      transform: translateY(-50%) rotate(45deg);
      width: 6px;
      height: 10px;
      border-right: 2px solid white;
      border-bottom: 2px solid white;
    }

    .hs-form-checkbox input[type='checkbox']:checked + span::before,
    .hs-form-checkbox
      .hs-form-checkbox-display:has(input[type='checkbox']:checked)::before {
      background: ${globalSystemColors.blue};
      border-color: ${globalSystemColors.blue};
    }

    .hs-form-checkbox span {
      color: ${globalSystemColors.cocoaBrown};
      font-size: 15px;
      margin: 0 !important;
    }

    .hs-form-booleancheckbox label {
      display: flex;
      gap: 10px;
      align-items: flex-start;
    }

    .hs-form-booleancheckbox input[type='checkbox'] {
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      margin: 0;
      padding: 0;
      -webkit-appearance: none;
      appearance: none;
    }

    .hs-form-booleancheckbox .hs-form-booleancheckbox-display {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      padding-left: 26px;
    }

    .hs-form-booleancheckbox .hs-form-booleancheckbox-display::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border: 1px solid #eaebf2;
      border-radius: 5px;
      background: ${globalSystemColors.white};
      box-sizing: border-box;
      transition:
        border-color 0.15s,
        box-shadow 0.15s,
        background-color 0.15s;
    }

    .hs-form-booleancheckbox
      .hs-form-booleancheckbox-display:has(
        input[type='checkbox']:checked
      )::before {
      background: ${globalSystemColors.blue};
      border-color: ${globalSystemColors.blue};
    }

    .hs-form-booleancheckbox input[type='checkbox']:checked + span::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 45%;
      transform: translateY(-50%) rotate(45deg);
      width: 6px;
      height: 10px;
      border-right: 2px solid ${globalSystemColors.white};
      border-bottom: 2px solid ${globalSystemColors.white};
    }

    .hs-form-booleancheckbox span {
      color: ${globalSystemColors.cocoaBrown};
      font-size: 15px;
      margin: 0 !important;
    }

    .hs-form-booleancheckbox span::before {
      content: none !important;
    }
  }

  .hs-button {
    border: 0;
    border-radius: 14px;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: ${FontWeight.medium};
    background: ${globalSystemColors.blue};
    color: ${globalSystemColors.white};
    cursor: pointer;
    transition:
      transform 0.05s,
      opacity 0.2s;
    min-width: 200px;
  }
  .hs-button:hover {
    opacity: 0.95;
  }
  .hs-button:active {
    transform: translateY(1px);
  }

  .hs-input.error {
    border-color: ${globalSystemColors.red};
    background: ${globalSystemColors.white};
    text-align: start;
  }

  .hs-error-msgs,
  .hs_error_rollup {
    position: static !important;
    list-style: none;
    pointer-events: none;
  }
  .hs-error-msg {
    font-size: 12px !important;
    color: ${globalSystemColors.red} !important;
    margin: 0 !important;
  }

  .hs_country_1 {
    display: none !important;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    .hs_firstname,
    .hs_lastname,
    .hs_email,
    .hs_phone,
    .hs_message {
      box-sizing: border-box;
      background: ${globalSystemColors.white};
      border-left: 1px solid
        ${({ theme }) => theme.colors.border.secondaryReverse};
      border-right: 1px solid
        ${({ theme }) => theme.colors.border.secondaryReverse};
      padding-left: 25px;
      padding-right: 25px;
      margin-top: -1px;
    }

    .hs-interest_new {
      border: 1px solid ${({ theme }) => theme.colors.border.secondaryReverse};
      padding: 25px;
      border-radius: 21px;
      min-height: 471px;
      margin-bottom: 25px;
    }

    .hs_firstname.hs-firstname {
      border-top: 1px solid
        ${({ theme }) => theme.colors.border.secondaryReverse};
      border-radius: 16px 16px 0 0;
      margin-top: 0;
      padding-top: 25px;
      padding-bottom: 15px;

      &:not(.hs-message) > label {
        left: 40px;
        top: 45px;
      }
    }

    .hs_lastname,
    .hs_email {
      padding-top: 0;
      padding-bottom: 15px;
    }

    .hs_phone {
      padding-top: 0;
      padding-bottom: 35px;
    }

    .hs_message {
      border-bottom: 1px solid
        ${({ theme }) => theme.colors.border.secondaryReverse};
      border-radius: 0 0 16px 16px;
      padding-top: 0;
      padding-bottom: 25px;
      margin-bottom: 25px;
    }

    .hs-form-field:not(.hs-message) > label {
      left: 40px;
      top: 20px;
    }
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    .hs-form {
      display: grid;
      grid-template-columns: 1fr;
      row-gap: 15px;
      align-items: start;
      grid-template-areas:
        'fn'
        'ln'
        'em'
        'ph'
        'msg'
        'interests'
        'cons'
        'submit';
    }

    .hs_firstname {
      grid-area: fn !important;
    }
    .hs_lastname {
      grid-area: ln !important;
    }
    .hs_email {
      grid-area: em !important;
    }
    .hs_phone {
      grid-area: ph !important;
    }
    .hs_message {
      grid-area: msg !important;
    }

    .hs-interest_new,
    .hs_interest_new {
      grid-area: interests !important;
    }

    .legal-consent-container {
      grid-area: cons !important;

      a {
        text-decoration: none;
      }
    }

    .hs_submit,
    .actions {
      grid-area: submit !important;
    }

    .hs_firstname.hs-firstname {
      margin-top: 0;
    }

    .hs-input,
    select.hs-input,
    textarea.hs-input {
      font-size: 15px;
    }

    .hs_phone {
      padding-top: 0;
      padding-bottom: 20px;
    }

    .hs_message {
      padding-top: 0;
      margin-bottom: 10px;
    }

    .hs-form-field:not(.hs-message) > label {
      left: 15px;
      top: 20px;
    }

    .legal-consent-container {
      grid-area: cons !important;
      align-self: end;
      margin-top: 35px;
      font-size: 15px;
      font-weight: 400;
      color: ${globalSystemColors.cocoaBrown};

      label {
        display: flex;
        align-items: center;

        span {
          margin-left: 8px;
        }
      }
    }
    .hs_submit,
    .actions {
      grid-area: submit !important;
      justify-self: end;
      align-self: center;
      margin: 0 !important;
      width: 100%;
    }

    .actions .hs-button {
      width: 100%;
      min-width: 200px;
    }
  }

  .hs-form fieldset.form-columns-1 .hs-form-field,
  .hs-form fieldset.form-columns-2 .hs-form-field {
    width: 100% !important;
    max-width: none !important;
  }
  .hs-form fieldset.form-columns-1 .hs-form-field .input,
  .hs-form fieldset.form-columns-2 .hs-form-field .input {
    width: 100% !important;
    max-width: none !important;
    margin-right: 0 !important;
  }

  .hs-form .hs_email .input > .hs-input,
  .hs-form .hs_message .input > .hs-input,
  .hs-form .hs_email .input > .hs-input.error,
  .hs-form .hs_message .input > .hs-input.error {
    width: 100% !important;
    max-width: none !important;
    display: block;
  }

  @media (max-width: 400px),
    (min-device-width: 320px) and (max-device-width: 480px) {
    .hs-form:not(.hs-video-form).hs-form
      fieldset.form-columns-2
      .hs-form-field
      .input
      > .hs-input,
    .hs-form:not(.hs-video-form).hs-form
      fieldset.form-columns-3
      .hs-form-field
      .input
      > .hs-input {
      width: 100% !important;
      max-width: none !important;
      box-sizing: border-box;
    }

    .hs-form fieldset.form-columns-2 .hs-form-field,
    .hs-form fieldset.form-columns-2 .hs-form-field .input,
    .hs-form fieldset.form-columns-3 .hs-form-field,
    .hs-form fieldset.form-columns-3 .hs-form-field .input {
      width: 100% !important;
      max-width: none !important;
      margin-right: 0 !important;
    }

    .hs-form .hs_phone .hs-fieldtype-intl-phone input.hs-input[type='tel'] {
      width: 70% !important;
      flex: 1 1 auto;
    }
  }

  .submitted-message {
    color: ${globalSystemColors.cocoaBrown};
    text-align: center;
  }

  @supports (-webkit-touch-callout: none) {
    input.hs-input,
    select.hs-input,
    textarea.hs-input,
    .hs_phone .input select.hs-input,
    .hs_phone .input input.hs-input[type='tel'],
    .hs_phone .input .hs-fieldtype-intl-phone {
      font-size: 16px !important;
      transform: scale(0.9375);
      transform-origin: left center;
    }

    .hs-form-field:not(.hs-message):not(.hs_phone):not(:focus-within):not(
        .has-value
      )
      > label {
      transform: none !important;
      opacity: 1 !important;
      font-size: 15px !important;
    }

    .hs-form-field:not(.hs-message):focus-within > label,
    .hs-form-field:not(.hs-message).has-value > label,
    .hs-form-field:not(.hs-message):has(input:-webkit-autofill) > label {
      transform: translateY(-12px) scale(0.86) !important;
      opacity: 0.95 !important;
      font-size: 14px !important;
    }

    .hs-form-field.hs_phone > label,
    .hs-form-field:has(.hs-fieldtype-intl-phone) > label {
      transform: translateY(-12px) scale(0.86) !important;
      opacity: 0.95 !important;
      font-size: 14px !important;
    }
  }
`;
